import { actionGenerator, IReduxAction } from '../../utils/actions';
import { ICheckServiceBalance } from '../../services/checkService';

export const UPDATE_BALANCE = 'BALANCE :: UPDATE_BALANCE';

export type TUpdateBalanceAction = IReduxAction<typeof UPDATE_BALANCE, ICheckServiceBalance>;

export const updateBalance = actionGenerator<typeof UPDATE_BALANCE, ICheckServiceBalance>(UPDATE_BALANCE);
